export class PhotoViewModel {
    id = 0;
    accomodationUnitTypeId = 0;

    filename = "";
    isMain = false;
    order = 0;

    title = "";
    altText = "";
    aria = "";

    tagIds: number[] = [];
}